module.exports = __webpack_public_path__ + "static/media/12.078dcaa6.PNG";